// import React from "react";

// const AboutUs = () => {
//   return (
//     <div className="bg-[#f1f7fd] text-dark">
//       {/* Hero Section */}
//       <section className="bg-primary text-white py-20 px-6 text-center">
//         <h1 className="text-4xl md:text-5xl font-bold mb-4">
//           About Tiranga Express
//         </h1>
//         <p className="max-w-3xl mx-auto text-lg">
//           Your trusted logistics partner for safe, reliable, and cost-effective moving and transportation solutions across India.
//         </p>
//       </section>

//       {/* Who We Are */}
//       <section className="py-16 px-6 max-w-6xl mx-auto text-center">
//         <h2 className="text-3xl font-bold text-primary mb-4">Who We Are</h2>
//         <p className="text-lg text-secondary max-w-3xl mx-auto">
//           Tiranga Express is a modern logistics and transportation platform offering end-to-end services like packers and movers, vehicle transportation, cargo delivery, warehousing, and much more. With verified service providers, instant quotes, and a dedicated support team, we make your shifting and logistics experience hassle-free and efficient.
//         </p>
//       </section>

//       {/* Mission & Vision */}
//       <section className="bg-white py-16 px-6">
//         <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
//           <div className="bg-[#d2e4f2] rounded-xl p-8 shadow">
//             <h3 className="text-2xl font-bold text-primary mb-3">Our Mission</h3>
//             <p className="text-secondary text-lg">
//               To empower individuals and businesses by providing seamless logistics solutions, connecting them with verified service providers and offering reliable services at competitive prices.
//             </p>
//           </div>
//           <div className="bg-[#d2e4f2] rounded-xl p-8 shadow">
//             <h3 className="text-2xl font-bold text-primary mb-3">Our Vision</h3>
//             <p className="text-secondary text-lg">
//               To become India’s most customer-centric logistics platform by revolutionizing the way people move goods, ensuring safety, speed, and satisfaction with every delivery.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="py-16 px-6 text-center">
//         <h2 className="text-3xl font-bold text-primary mb-4">Why Choose Tiranga Express?</h2>
//         <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-10">
//           <div className="bg-white rounded-xl p-6 shadow-md">
//             <h4 className="text-xl font-bold text-dark mb-2">Verified Partners</h4>
//             <p className="text-secondary">
//               All our service providers are thoroughly verified to ensure you get top-notch and secure logistics solutions.
//             </p>
//           </div>
//           <div className="bg-white rounded-xl p-6 shadow-md">
//             <h4 className="text-xl font-bold text-dark mb-2">Compare & Save</h4>
//             <p className="text-secondary">
//               Get instant quotes from multiple logistics companies. Compare and save up to 25% on your move or delivery.
//             </p>
//           </div>
//           <div className="bg-white rounded-xl p-6 shadow-md">
//             <h4 className="text-xl font-bold text-dark mb-2">24x7 Support</h4>
//             <p className="text-secondary">
//               Our dedicated customer support team is available around the clock to assist you at every step of your journey.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="bg-primary text-white py-16 px-6 text-center">
//         <h2 className="text-3xl font-bold mb-4">Ready to move with us?</h2>
//         <p className="mb-6 max-w-xl mx-auto">
//           Connect with India’s most reliable logistics platform today. Get quotes, compare, and move with confidence!
//         </p>
//         <button className="bg-white text-primary font-semibold px-6 py-3 rounded hover:bg-light transition">
//           Book Your Service
//         </button>
//       </section>
//     </div>
//   );
// };

// export default AboutUs;

import React from "react";
import bgImg from '../assets/bg.png'; // Import the background image

const AboutUs = () => {
  return (
    <div className="bg-[#f1f7fd] text-dark">
      {/* Hero Section with Divider */}
      <section
        className="relative bg-light bg-cover bg-center bg-no-repeat py-16 px-8 text-center"
        style={{
          backgroundImage: `url(${bgImg})`,
        }}
      >
        <div className="absolute inset-0 bg-black/40 z-0" />
          <div className="relative z-10">
        <h1 className="text-5xl md:text-5xl font-bold mb-4 text-white">
          About 
        </h1>
        {/* Tiranga Express */}
        <p className="max-w-3xl mx-auto text-lg text-white">
          Your trusted logistics partner for safe, reliable, and cost-effective
          moving and transportation solutions across India.
        </p>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-16 px-6 max-w-6xl mx-auto text-center relative z-10">
        <h2 className="text-3xl font-bold text-[#003E7E] mb-4">Who We Are</h2>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Tiranga Express is a modern logistics and transportation platform
          offering end-to-end services like packers and movers, vehicle
          transportation, cargo delivery, warehousing, and much more. With
          verified service providers, instant quotes, and a dedicated support
          team, we make your shifting and logistics experience hassle-free and
          efficient.
        </p>
      </section>

      {/* Mission & Vision */}
      <section className="bg-white py-16 px-6 relative z-10">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          <div className="bg-[#d2e4f2] rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-[#003E7E] mb-3">
              Our Mission
            </h3>
            <p className="text-gray-700 text-lg">
              To empower individuals and businesses by providing seamless
              logistics solutions, connecting them with verified service
              providers and offering reliable services at competitive prices.
            </p>
          </div>
          <div className="bg-[#d2e4f2] rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-[#003E7E] mb-3">
              Our Vision
            </h3>
            <p className="text-gray-700 text-lg">
              To become India’s most customer-centric logistics platform by
              revolutionizing the way people move goods, ensuring safety, speed,
              and satisfaction with every delivery.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 px-6 text-center relative z-10">
        <h2 className="text-3xl font-bold text-[#003E7E] mb-4">
          Why Choose Tiranga Express?
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-10">
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300">
            <h4 className="text-xl font-bold text-[#003E7E] mb-2">
              Verified Partners
            </h4>
            <p className="text-gray-700">
              All our service providers are thoroughly verified to ensure you
              get top-notch and secure logistics solutions.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300">
            <h4 className="text-xl font-bold text-[#003E7E] mb-2">
              Compare & Save
            </h4>
            <p className="text-gray-700">
              Get instant quotes from multiple logistics companies. Compare and
              save up to 25% on your move or delivery.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300">
            <h4 className="text-xl font-bold text-[#003E7E] mb-2">
              24x7 Support
            </h4>
            <p className="text-gray-700">
              Our dedicated customer support team is available around the clock
              to assist you at every step of your journey.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#003E7E] text-white py-16 px-6 text-center relative z-10">
        <h2 className="text-3xl font-bold mb-4">Ready to move with us?</h2>
        <p className="mb-6 max-w-xl mx-auto">
          Connect with India’s most reliable logistics platform today. Get
          quotes, compare, and move with confidence!
        </p>
        <button className="bg-white text-[#003E7E] font-semibold px-6 py-3 rounded hover:bg-gray-200 transition">
          Book Your Service
        </button>
      </section>
    </div>
  );
};

export default AboutUs;
